import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { Cuisine } from '../../types';

interface CuisineState {
  items: Cuisine[];
  loading: boolean;
  error: string | null;
}

const initialState: CuisineState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchCuisines = createAsyncThunk(
  'cuisines/fetchCuisines',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<Cuisine[]>('/api/cuisines/');
      return response.data;
    } catch (error) {
      return rejectWithValue('Failed to fetch cuisines');
    }
  }
);

const cuisineSlice = createSlice({
  name: 'cuisines',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCuisines.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCuisines.fulfilled, (state, action: PayloadAction<Cuisine[]>) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCuisines.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default cuisineSlice.reducer; 